import axios from 'axios';

const BASE_URL = '/app/opportunityFunnel';

export const getOpportunityConfig = async () => {
    const { data: opportunityConfigDto } = await axios.get(`${BASE_URL}/config`);

    return opportunityConfigDto;
};
